import { PickleballGameFormat } from "./enums/pickleball-game-format";

export enum SetType {
    STANDARD = 'STANDARD',
    TIEBREAK = 'TIEBREAK',
    TIMED = 'TIMED',
    RALLY = 'RALLY',
    MLP = 'MLP'
}

export enum TimedPointsOrGames {
    POINT = 'P',
    GAME  = 'G'
}
// Score format example: SET3-S:6NOAD/TB7@6-F:TB10
export class ScoreFormat {

    // NOAD - If false it's no-ad match
    ads?: boolean;
    // G:30 - If number specified it tells at what point each game starts
    gameStartingPoint?: number;
    // SET3 Maximum number of sets that can be played in the match
    numberOfSets: number;
    // S:6 - Number of games played in the set
    numberOfGamesInSet: number;
    // Number of sets needed to win the match
    numberOfSetsToWin: number;
    // If there is a change on last set it tells us to what type it has changed (i.e. TB10, WB2...)
    lastSet?: string;
    // setType can be STANDARD or TIEBREAK or RALLY or MLP
    setType?: SetType;
    // @6 - At what game of tiebreak is played in standard set
    tiebreakAt?: number;
    // 7 - How many points is needed to win tiebreak win by 2
    tiebreakTo?: number;
    // TB7 - There might be possibility to lose
    tiebreakType?: string;
    // 10 - How many points is needed to win match tiebreak
    lastSetTiebreakTo?: number;
    // WB2 - is last set win by 2
    winBy2?: boolean;
    // For timed matches it can be set as points or games
    timedPointsOrGames?: TimedPointsOrGames;
    // How long is timed set in minutes
    timedSetDuration?: number;
    // Number of points in game, used in Pickleball
    numberOfPointsInGame?: number;
    // Used in pickleball if the last set is different
    lastSetGameType?: SetType;
    // Used in pickleball if the last set is different
    lastSetNumberOfPoints?: number;
    // Used in pickleball if the last set is different
    lastSetGameFormat?: PickleballGameFormat;
    // Cap of points in badminton
    capOfPoints?: number;
}
